import React from 'react'
import IconsContainer from 'app/react/components/icons/IconsContainer'
import IconsContent from 'app/react/components/icons/IconsContent'

export default function IconsOverview (props) {
  return (
    <IconsContainer {...props}>
      <IconsContent/>
    </IconsContainer>
  )
}